<template>
  <div class="ca-page">
    <div class="ca-body">
      <!-- Toolbar -->
      <div class="ca-toolbar">
        <div class="ca-toolbar-title">APN 管理</div>
        <span v-if="ov.partner" class="om-partner">{{ ov.partner }}</span>
        <el-date-picker v-model="fMonth" type="month" value-format="YYYYMM" format="YYYY-MM" clearable placeholder="全部月份" class="om-month" @change="onMonthChange" />
        <span class="om-month-tip">{{ fMonth ? '按商机创建月份筛选，层级图费用取同月' : '' }}</span>
        <div class="ca-toolbar-spacer"></div>
        <span class="om-conn">
          <i :class="['om-conn-dot', { busy: ov.running }]"></i>APN Partner Central
          <span class="om-conn-time">{{ ov.running ? '同步中…' : (ov.last_sync ? '上次同步 ' + fmtTime(ov.last_sync) : '未同步') }}</span>
        </span>
        <button v-if="ov.is_admin" class="ca-ghost-btn" :disabled="ov.running" @click="syncApn">{{ ov.running ? '同步中…' : '同步 APN' }}</button>
        <button class="ca-export-btn" @click="openSubmit(null)">+ 新建商机</button>
      </div>

      <!-- KPI -->
      <div class="ca-kpi-row">
        <div v-for="kpi in kpiList" :key="kpi.label" class="ca-kpi-card om-kpi-click" @click="kpi.go && kpi.go()">
          <div class="ca-kpi-icon-wrap" :style="{ background: kpi.iconBg }"><span class="om-kpi-dot" :style="{ background: kpi.iconColor }"></span></div>
          <div>
            <div class="ca-kpi-label">{{ kpi.label }}</div>
            <div class="ca-kpi-value" :style="{ color: kpi.valueColor }">{{ kpi.value }}</div>
          </div>
        </div>
      </div>

      <div class="ca-card">
        <div class="ca-card-header ca-card-header-between">
          <div class="om-tabs">
            <button :class="['om-tab', { active: tab === 'map' }]" @click="tab = 'map'">账号层级图</button>
            <button :class="['om-tab', { active: tab === 'list' }]" @click="tab = 'list'">商机列表<span class="ca-tab-badge ca-badge-blue">{{ ov.kpi.total }}</span></button>
            <button v-if="ov.is_admin" :class="['om-tab', { active: tab === 'invite' }]" @click="tab = 'invite'">AWS 推荐<span v-if="ov.kpi.pending_invites" class="ca-tab-badge ca-badge-orange">{{ ov.kpi.pending_invites }}</span></button>
          </div>
          <div v-if="tab === 'map'" class="ca-filters">
            <div class="om-seg">
              <button :class="{ active: view === 'biz' }" @click="switchView('biz')">业务视角</button>
              <button :class="{ active: view === 'payer' }" @click="switchView('payer')">Payer 视角</button>
            </div>
            <el-select v-model="mSales" filterable clearable placeholder="全部销售" class="om-m-sm" @change="onMapFilter('sales')">
              <el-option v-for="s in mapSalesOptions" :key="s" :label="s" :value="s" />
            </el-select>
            <el-select v-model="mAgent" filterable clearable placeholder="全部伙伴" class="om-m-md" @change="onMapFilter('agent')">
              <el-option v-for="a in mapAgentOptions" :key="a.value" :label="a.label" :value="a.value" />
            </el-select>
            <el-select v-model="mCustomer" filterable clearable :filter-method="kw => (custKw = kw)" placeholder="全部客户" class="om-m-md" @change="onMapFilter('customer')" @visible-change="v => v || (custKw = '')">
              <el-option v-for="c in mapCustomerOptions" :key="c" :label="c" :value="c" />
            </el-select>
            <el-select v-model="mLink" filterable clearable :filter-method="kw => (linkKw = kw)" placeholder="全部账号ID" class="om-m-md" @change="onMapFilter('link')" @visible-change="v => v || (linkKw = '')">
              <el-option v-for="l in mapLinkOptions" :key="l.link_id" :label="`${l.link_id} · ${l.name || ''}`" :value="l.link_id" />
            </el-select>
            <span class="om-switch-label">只看有商机</span>
            <el-switch v-model="onlyWithOpp" size="small" />
            <button class="ca-ghost-btn ca-ghost-sm" @click="collapseAll">收起</button>
            <button class="ca-ghost-btn ca-ghost-sm" @click="resetView">重置视图</button>
          </div>
        </div>

        <!-- 层级图 -->
        <div v-show="tab === 'map'" v-loading="treeLoading" class="om-map-layout">
          <div class="om-map-main">
            <div class="om-legend">
              <span v-for="t in legendTypes" :key="t.type" class="om-legend-item"><i :style="{ borderColor: t.color, background: t.bg }"></i>{{ t.label }}</span>
              <span class="om-legend-item"><b class="om-legend-opp">N</b>进行中商机</span>
              <span class="om-legend-hint">费用月份 {{ treeMonth }}<template v-if="fMonth"> · 商机创建月份 {{ fMonth }}</template> · 单击：选中/展开 · 右键：快捷操作 · 拖拽平移</span>
            </div>
            <div class="om-chart-scroll">
              <div class="om-chart-inner">
                <div ref="chart" class="om-chart" :style="{ height: chartHeight + 'px' }"></div>
                <div v-if="ctxMenu.show && ctxNode" class="om-ctx" :style="{ left: ctxMenu.x + 'px', top: ctxMenu.y + 'px' }" @click.stop>
                  <div class="om-ctx-title">{{ ctxNode.name }}</div>
                  <button v-for="a in nodeActions(ctxNode)" :key="a.key" class="om-ctx-item" :disabled="a.disabled" :title="a.tip" @click="doAction(a.key, ctxNode.id)">{{ a.label }}</button>
                </div>
              </div>
            </div>
          </div>

          <!-- 节点详情 -->
          <div class="om-side">
            <div v-if="!selected" class="om-side-empty">
              <div class="om-side-empty-icon">◎</div>
              点击图中任一节点<br />查看账号、关联商机，并可跳转或提交商机
            </div>
            <template v-else>
              <div class="om-side-head">
                <span class="om-type-chip" :style="typeChipStyle(selected.type)">{{ typeMeta[selected.type].label }}</span>
                <div class="om-side-name">{{ selected.name }}</div>
                <div class="om-side-sub">{{ selected.sub }}</div>
                <div v-if="selected.region === 'cn'" class="om-cn-tip">中国区账号：AWS 中国区不在 APN / ACE 覆盖范围，不可提交商机</div>
              </div>
              <div class="om-side-stats">
                <div><div class="ca-detail-label">账号数</div><div class="ca-detail-value">{{ selected.linkCount }}</div></div>
                <div><div class="ca-detail-label">{{ treeMonth }} 费用</div><div class="ca-detail-value">{{ fmtUsd(selected.cost) }}</div></div>
                <div><div class="ca-detail-label">进行中商机</div><div class="ca-detail-value ca-text-primary">{{ selected.oppCount }}</div></div>
                <div><div class="ca-detail-label">预计月消费</div><div class="ca-detail-value">{{ fmtUsd(selected.mrr) }}</div></div>
              </div>
              <div class="om-side-actions">
                <button v-for="a in nodeActions(selectedNode)" :key="a.key" :class="a.primary ? 'ca-export-btn ca-btn-sm' : 'ca-ghost-btn ca-ghost-sm'" :disabled="a.disabled" :title="a.tip" @click="doAction(a.key, selected.id)">{{ a.label }}</button>
              </div>
              <div class="om-side-section">
                关联商机（{{ sideOpps.total }}）
                <a v-if="sideOpps.total > sideOpps.items.length" class="om-more-link" @click="doAction('opps', selected.id)">查看全部</a>
              </div>
              <div v-loading="sideOpps.loading" class="om-side-opps">
                <div v-if="!sideOpps.items.length && !sideOpps.loading" class="ca-empty">暂无商机</div>
                <div v-for="o in sideOpps.items" :key="o.id" class="om-opp-mini" @click="openDrawer(o.id)">
                  <div class="om-opp-mini-title">{{ o.title || o.company }}</div>
                  <div class="om-opp-mini-meta">
                    <span class="ca-sev-badge" :style="stageStyle(o.stage)">{{ stageLabel(o.stage) }}</span>
                    <span :class="['ca-sev-badge', 'ca-sev-' + reviewMeta(o.review_status).cls]">{{ reviewMeta(o.review_status).label }}</span>
                    <span class="ca-text-muted ca-font-data">{{ fmtUsd(o.mrr) }}/月</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- 商机列表 -->
        <div v-show="tab === 'list'">
          <div class="ca-filters om-list-filters">
            <span v-if="scopeFilter.label" class="om-scope-chip">范围：{{ scopeFilter.label }}<b @click="clearScope">×</b></span>
            <el-input v-model="q" clearable placeholder="搜索 商机/客户/ID/账号/伙伴/邮箱" class="om-q" @keyup.enter="reloadList(1)" @clear="reloadList(1)" />
            <el-select v-model="fStage" filterable clearable placeholder="全部阶段" class="ca-filter-select" @change="reloadList(1)">
              <el-option v-for="s in stages" :key="s.value" :label="s.label" :value="s.value" />
            </el-select>
            <el-select v-model="fReview" filterable clearable placeholder="全部审核状态" class="ca-filter-select" @change="reloadList(1)">
              <el-option v-for="(v, k) in reviewStatus" :key="k" :label="v.label" :value="k" />
            </el-select>
            <el-select v-model="fOrigin" filterable clearable placeholder="全部来源" class="ca-filter-sm" @change="reloadList(1)">
              <el-option v-for="(v, k) in origins" :key="k" :label="v" :value="k" />
            </el-select>
            <el-select v-if="ov.is_admin" v-model="fLinked" filterable clearable placeholder="关联账号" class="ca-filter-sm" @change="reloadList(1)">
              <el-option label="已关联平台账号" value="1" /><el-option label="未关联" value="0" />
            </el-select>
            <el-select v-if="ov.is_admin" v-model="fSales" filterable clearable placeholder="全部销售" class="ca-filter-sm" @change="reloadList(1)">
              <el-option v-for="s in salesOptions" :key="s" :label="s" :value="s" />
            </el-select>
            <button class="ca-ghost-btn ca-ghost-sm" @click="reloadList(1)">查询</button>
          </div>
          <div v-loading="list.loading" class="ca-table-wrap">
            <table class="ca-table">
              <thead>
                <tr><th>商机</th><th>客户 / AWS 账号</th><th>平台归属</th><th>阶段</th><th>审核</th><th>来源</th><th>预计月消费</th><th>预计关闭</th><th>最近更新</th><th>操作</th></tr>
              </thead>
              <tbody>
                <tr v-for="o in list.items" :key="o.id" class="ca-table-row">
                  <td class="om-td-title">
                    <div class="ca-td-primary om-link" @click="openDrawer(o.id)">{{ o.title || '(无标题)' }}</div>
                    <div class="ca-td-muted ca-font-data">{{ o.id }}<span v-if="o.catalog !== 'AWS'" class="om-cat-tag">{{ o.catalog }}</span></div>
                  </td>
                  <td>
                    <div class="ca-td-bold">{{ o.company }}</div>
                    <div class="ca-td-muted ca-font-data">{{ o.aws_account_id || '未填 AWS 账号' }}</div>
                  </td>
                  <td>
                    <template v-if="o.link_id"><div>{{ o.agent_company || '-' }}</div><div class="ca-td-muted">{{ o.sales }} · {{ o.link_name }}</div></template>
                    <span v-else class="ca-td-muted">未关联平台账号</span>
                  </td>
                  <td><span class="ca-sev-badge" :style="stageStyle(o.stage)">{{ stageLabel(o.stage) }}</span></td>
                  <td><span :class="['ca-sev-badge', 'ca-sev-' + reviewMeta(o.review_status).cls]">{{ reviewMeta(o.review_status).label }}</span></td>
                  <td class="ca-nowrap">
                    <div>{{ origins[o.origin] || o.origin || '-' }}</div>
                    <div v-if="o.involvement" class="ca-td-muted">{{ o.involvement === 'Co-Sell' ? 'Co-Sell' : '仅报备' }}</div>
                  </td>
                  <td class="ca-font-data ca-td-bold">{{ o.mrr ? fmtUsd(o.mrr) : '-' }}</td>
                  <td class="ca-font-data ca-nowrap">{{ o.target_close_date || '-' }}</td>
                  <td class="ca-font-data ca-nowrap ca-td-muted">{{ o.last_modified || o.created_at }}</td>
                  <td class="ca-nowrap">
                    <button class="om-op" @click="openDrawer(o.id)">详情</button>
                    <button class="om-op" :disabled="!o.link_id" @click="locateLink(o.link_id)">定位</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!list.items.length && !list.loading" class="ca-empty">没有符合条件的商机</div>
          </div>
          <div class="om-pager">
            <el-pagination background layout="total, prev, pager, next, sizes" :total="list.total" :page-size="list.limit" :current-page="list.page" :page-sizes="[20, 50, 100]" @current-change="reloadList" @size-change="onSizeChange" />
          </div>
        </div>

        <!-- AWS 推荐 -->
        <div v-if="ov.is_admin" v-show="tab === 'invite'" v-loading="invites.loading" class="om-invite-wrap">
          <div class="om-invite-tip">
            AWS 推送给佳杰的商机邀请（Engagement Invitation），共 {{ invites.items.length }} 条（最近 200）。
            <template v-if="ov.write_catalog !== 'AWS'">当前为 Sandbox 写入模式，生产邀请请在 Partner Central 中接受/拒绝。</template>
          </div>
          <div class="ca-filters om-invite-filter">
            <el-select v-model="fInvite" filterable clearable placeholder="全部状态" class="ca-filter-select" @change="loadInvites">
              <el-option v-for="(v, k) in inviteStatus" :key="k" :label="v.label" :value="k" />
            </el-select>
          </div>
          <div class="ca-table-wrap">
            <table class="ca-table">
              <thead><tr><th>标题</th><th>客户</th><th>发起方</th><th>状态</th><th>预计月消费</th><th>邀请日期</th><th>到期</th><th>操作</th></tr></thead>
              <tbody>
                <tr v-for="it in invites.items" :key="it.id" class="ca-table-row">
                  <td class="om-td-title"><div class="ca-td-bold">{{ it.title }}</div><div class="ca-td-muted ca-font-data">{{ it.id }}</div></td>
                  <td>{{ it.company || '-' }}</td>
                  <td>{{ it.sender_company || '-' }}</td>
                  <td><span :class="['ca-sev-badge', 'ca-sev-' + inviteMeta(it.status).cls]">{{ inviteMeta(it.status).label }}</span></td>
                  <td class="ca-font-data">{{ it.mrr ? fmtUsd(it.mrr) : '-' }}</td>
                  <td class="ca-font-data ca-nowrap">{{ it.invitation_date }}</td>
                  <td class="ca-font-data ca-nowrap">{{ it.expiration_date }}</td>
                  <td class="ca-nowrap">
                    <template v-if="it.status === 'PENDING'">
                      <button class="om-op om-op-primary" :disabled="!it.writable" :title="it.writable ? '' : '生产写入未开启'" @click="inviteAction(it, 'accept')">接受</button>
                      <button class="om-op" :disabled="!it.writable" :title="it.writable ? '' : '生产写入未开启'" @click="inviteAction(it, 'reject')">拒绝</button>
                    </template>
                    <span v-else class="ca-td-muted">-</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!invites.items.length && !invites.loading" class="ca-empty">暂无邀请</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 商机详情 -->
    <el-drawer v-model="drawer" size="560px" :with-header="false">
      <div v-loading="detail.loading" class="om-drawer-body">
        <template v-if="detail.data">
          <div class="om-drawer-head">
            <div class="om-drawer-title">{{ detail.data.title || detail.data.company }}</div>
            <div class="om-drawer-badges">
              <span :class="['ca-sev-badge', 'ca-sev-' + reviewMeta(detail.data.review_status).cls]">{{ reviewMeta(detail.data.review_status).label }}</span>
              <span class="ca-sev-badge ca-sev-gray">{{ origins[detail.data.origin] || detail.data.origin || '-' }}</span>
              <span class="ca-td-muted ca-font-data">{{ detail.data.id }} · {{ detail.data.catalog }}</span>
            </div>
          </div>
          <div class="om-drawer-section">
            <el-steps v-if="detail.data.stage !== 'Closed Lost'" :active="stageIndex(detail.data.stage)" finish-status="success" align-center class="om-steps">
              <el-step v-for="s in openStages" :key="s.value" :title="s.label" />
            </el-steps>
            <div v-else class="om-lost">该商机已丢单 · {{ detail.data.closed_lost_reason || '-' }}</div>
          </div>
          <div v-if="detail.data.review_comments || detail.data.review_reason" class="om-review-note">
            AWS 审核意见：{{ detail.data.review_reason }} {{ detail.data.review_comments }}
          </div>
          <div class="om-drawer-section ca-detail-grid om-drawer-grid">
            <div><div class="ca-detail-label">客户</div><div class="ca-detail-value ca-detail-text">{{ detail.data.company }}</div></div>
            <div><div class="ca-detail-label">AWS 账号</div><div class="ca-detail-value ca-detail-text ca-font-data">{{ detail.data.aws_account_id || '-' }}</div></div>
            <div><div class="ca-detail-label">平台归属</div><div class="ca-detail-value ca-detail-text">{{ detail.data.link_id ? (detail.data.agent_company || '-') + ' / ' + detail.data.sales : '未关联' }}</div></div>
            <div><div class="ca-detail-label">预计月消费</div><div class="ca-detail-value">{{ detail.data.mrr ? fmtUsd(detail.data.mrr) : '-' }}</div></div>
            <div><div class="ca-detail-label">预计关闭</div><div class="ca-detail-value ca-detail-text">{{ detail.data.target_close_date || '-' }}</div></div>
            <div><div class="ca-detail-label">机会类型</div><div class="ca-detail-value ca-detail-text">{{ oppTypeLabel(detail.data.opp_type) }}</div></div>
            <div><div class="ca-detail-label">用例</div><div class="ca-detail-value ca-detail-text">{{ detail.data.use_case || '-' }}</div></div>
            <div><div class="ca-detail-label">行业</div><div class="ca-detail-value ca-detail-text">{{ industryLabel(detail.data.industry) }}</div></div>
            <div><div class="ca-detail-label">APN 团队</div><div class="ca-detail-value ca-detail-text">{{ teamLabel(detail.data.team) }}</div></div>
            <div><div class="ca-detail-label">需要 AWS 支持</div><div class="ca-detail-value ca-detail-text">{{ (detail.data.needs || []).join('、') || '-' }}</div></div>
          </div>
          <div class="om-drawer-section">
            <div class="ca-detail-label">客户业务问题</div>
            <div class="ca-detail-desc om-problem">{{ detail.data.problem || '-' }}</div>
          </div>
          <div class="om-drawer-section om-stage-update">
            <el-select v-model="nextStage" filterable placeholder="推进到阶段" class="ca-filter-select" :disabled="!detail.data.writable">
              <el-option v-for="s in openStages" :key="s.value" :label="s.label" :value="s.value" />
            </el-select>
            <button class="ca-ghost-btn ca-ghost-sm" :disabled="!nextStage || !detail.data.writable || stageSaving" @click="updateStage">{{ stageSaving ? '更新中…' : '更新阶段' }}</button>
            <span v-if="!detail.data.writable" class="ca-td-muted">{{ detail.data.catalog }} 目录未开放写入，请在 Partner Central 操作</span>
            <span v-else class="ca-td-muted">待提交/审核中的商机 AWS 不允许改阶段</span>
          </div>
          <div class="om-drawer-section">
            <div class="om-side-section">时间线</div>
            <el-timeline class="om-timeline">
              <el-timeline-item v-for="(t, i) in detail.data.timeline.slice().reverse()" :key="i" :timestamp="t.time + ' · ' + t.by" placement="top">{{ t.text }}</el-timeline-item>
            </el-timeline>
          </div>
          <div class="om-drawer-foot">
            <button class="ca-ghost-btn ca-ghost-sm" :disabled="!detail.data.link_id" @click="locateLink(detail.data.link_id)">在层级图定位</button>
            <button class="ca-ghost-btn ca-ghost-sm" :disabled="!detail.data.link_id" @click="goPage('/costExplorer', { link_id: detail.data.link_id })">成本分析</button>
          </div>
        </template>
      </div>
    </el-drawer>

    <!-- 新建 / 提交商机 -->
    <el-dialog v-model="submitVisible" width="860px" top="5vh">
      <template #header>
        <span class="om-dialog-title">新建商机</span>
      </template>
      <el-form ref="oppForm" :model="form" :rules="rules" label-position="top" class="om-form">
        <div class="om-form-group">客户与账号</div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="客户公司" prop="company">
              <el-select v-model="form.company" filterable remote allow-create default-first-option :remote-method="searchCustomers" placeholder="输入搜索平台客户，或直接填写新客户" style="width:100%" @change="onCompanyChange">
                <el-option v-for="c in customerOptions" :key="c" :label="c" :value="c" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关联 AWS 账号（AwsAccountId）" prop="link_id">
              <el-select v-model="form.link_id" filterable clearable placeholder="关联后可在层级图中展示" style="width:100%">
                <el-option v-for="l in linkOptions" :key="l.link_id" :label="l.name + ' · ' + l.link_id + (l.region === 'cn' ? ' · 中国区不支持' : '')" :value="l.link_id" :disabled="l.region === 'cn'" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="行业" prop="industry">
              <el-select v-model="form.industry" filterable placeholder="选择行业" style="width:100%">
                <el-option v-for="i in industries" :key="i.value" :label="i.label" :value="i.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户官网" prop="website"><el-input v-model="form.website" placeholder="https://" /></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="国家/地区">
              <el-select v-model="form.country" filterable style="width:100%">
                <el-option label="中国 CN" value="CN" /><el-option label="中国香港 HK" value="HK" /><el-option label="新加坡 SG" value="SG" /><el-option label="美国 US" value="US" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="om-form-group">项目信息</div>
        <el-row :gutter="16">
          <el-col :span="16"><el-form-item label="商机标题" prop="title"><el-input v-model="form.title" maxlength="255" /></el-form-item></el-col>
          <el-col :span="8">
            <el-form-item label="机会类型">
              <el-select v-model="form.opp_type" filterable style="width:100%"><el-option v-for="t in oppTypes" :key="t.value" :label="t.label" :value="t.value" /></el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="客户业务问题（≥20 字，ACE 审核重点）" prop="problem">
              <el-input v-model="form.problem" type="textarea" :rows="3" maxlength="2000" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用例" prop="use_case">
              <el-select v-model="form.use_case" filterable style="width:100%"><el-option v-for="u in useCases" :key="u" :label="u" :value="u" /></el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交付模式">
              <el-select v-model="form.delivery_models" multiple filterable style="width:100%"><el-option v-for="d in deliveryModels" :key="d" :label="d" :value="d" /></el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计月消费（USD）" prop="mrr"><el-input-number v-model="form.mrr" :min="0" :step="500" controls-position="right" style="width:100%" /></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计关闭日期" prop="close_date">
              <el-date-picker v-model="form.close_date" type="date" value-format="YYYY-MM-DD" :disabled-date="pastDate" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="当前阶段">
              <el-select v-model="form.stage" filterable style="width:100%"><el-option v-for="s in openStages" :key="s.value" :label="s.label" :value="s.value" /></el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="om-form-group">与 AWS 协同</div>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="合作方式（InvolvementType）">
              <el-select v-model="form.involvement" filterable style="width:100%">
                <el-option label="Co-Sell（需 AWS 协同）" value="Co-Sell" />
                <el-option label="For Visibility Only（仅报备）" value="For Visibility Only" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="需要 AWS 提供的支持" prop="needs">
              <el-select v-model="form.needs" multiple filterable :disabled="form.involvement !== 'Co-Sell'" style="width:100%">
                <el-option v-for="n in awsNeeds" :key="n" :label="n" :value="n" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="APN 提交人（OpportunityTeam）" prop="apn_user">
              <el-select v-model="form.apn_user" filterable placeholder="选择 Partner Central 用户" style="width:100%">
                <el-option v-for="u in apnUsers" :key="u.email" :label="u.name + ' · ' + u.email" :value="u.email" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="下一步"><el-input v-model="form.next_steps" maxlength="255" /></el-form-item></el-col>
          <el-col :span="24">
            <el-form-item label="解决方案说明（OtherSolutionDescription，ACE 提交必填）" prop="solution">
              <el-input v-model="form.solution" maxlength="255" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-collapse v-model="showPayload" class="om-payload">
        <el-collapse-item title="APN API 请求预览（Partner Central Selling API）" name="p">
          <div class="om-payload-step">① CreateOpportunity（{{ ov.write_catalog }}）</div>
          <pre>{{ payloadPreview }}</pre>
          <div class="om-payload-step">② StartEngagementFromOpportunityTask（「创建并提交」时调用，进入 AWS 审核）</div>
          <pre>{{ submitPreview }}</pre>
        </el-collapse-item>
      </el-collapse>
      <template #footer>
        <span class="om-foot-tip">「仅创建」只建商机不提交审核；「创建并提交」会立即进入 AWS 审核</span>
        <el-button :disabled="submitting" @click="submitVisible = false">取消</el-button>
        <el-button :loading="submitting" @click="saveOpp(false)">仅创建</el-button>
        <el-button type="primary" :loading="submitting" @click="saveOpp(true)">创建并提交 AWS 审核</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  apnOverview, apnTree, apnList, apnDetail, apnInvitations, apnSync, apnCreate, apnUpdateStage, apnInvitationAction,
} from '@/api/api'
import {
  STAGES, REVIEW_STATUS, ORIGINS, INVITE_STATUS, INDUSTRIES, USE_CASES, DELIVERY_MODELS, OPP_TYPES, AWS_NEEDS,
  APN_USERS, apnUserOfSales,
} from './apnConstants'

const TYPE_META = {
  root: { label: '总览', color: '#232f3e', bg: '#232f3e', border: '#232f3e', size: 14 },
  sales: { label: '销售', color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe', size: 12 },
  agent: { label: '伙伴', color: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe', size: 11 },
  customer: { label: '客户', color: '#059669', bg: '#ecfdf5', border: '#a7f3d0', size: 10 },
  payer: { label: 'Payer', color: '#d97706', bg: '#fffbeb', border: '#fde68a', size: 12 },
  link: { label: '账号', color: '#475569', bg: '#ffffff', border: '#e4e4e7', size: 8 },
  more: { label: '更多', color: '#a1a1aa', bg: '#fafafa', border: '#e4e4e7', size: 6 },
}
const CHILD_PAGE = 30
const OPTION_MAX = 100
const SIDE_LIMIT = 10
const POLL_MS = 3000
const ROUTES = {
  cost: '/costExplorer', bill: '/billManage', linker: '/linkerManage', agent: '/agentManage',
  customer: '/customerManage', payer: '/payerManage', sales: '/saleManage',
}

function trunc(s, n) { s = String(s || ''); return s.length > n ? s.slice(0, n - 1) + '…' : s }
function ok(res) { return res && res.code === 2000 }

export default {
  name: 'opportunityManage',
  data() {
    return {
      typeMeta: TYPE_META,
      stages: STAGES,
      openStages: STAGES.filter(s => s.value !== 'Closed Lost'),
      reviewStatus: REVIEW_STATUS,
      origins: ORIGINS,
      inviteStatus: INVITE_STATUS,
      industries: INDUSTRIES,
      useCases: USE_CASES,
      deliveryModels: DELIVERY_MODELS,
      oppTypes: OPP_TYPES,
      awsNeeds: AWS_NEEDS,
      apnUsers: APN_USERS,
      legendTypes: ['sales', 'agent', 'customer', 'payer', 'link'].map(t => ({ type: t, ...TYPE_META[t] })),

      ov: { kpi: { total: 0, open: 0, todo: 0, open_mrr: 0, linked: 0, pending_invites: 0 }, is_admin: false, write_catalog: 'Sandbox', partner: '', last_sync: '', running: false },
      tab: 'map',
      view: 'biz',
      onlyWithOpp: false,
      treeLoading: false,
      treeMonth: '',
      salesOptions: [],
      fMonth: '',
      mSales: '', mAgent: '', mCustomer: '', mLink: '',
      custKw: '', linkKw: '',
      treeVersion: 0,
      selected: null,
      chartHeight: 560,
      ctxMenu: { show: false, x: 0, y: 0, nodeId: '' },
      sideOpps: { items: [], total: 0, loading: false },

      list: { items: [], total: 0, page: 1, limit: 20, loading: false },
      q: '', fStage: '', fReview: '', fOrigin: '', fSales: '', fLinked: '',
      scopeFilter: { label: '', params: {} },

      invites: { items: [], loading: false },
      fInvite: '',

      drawer: false,
      detail: { data: null, loading: false },
      nextStage: '',
      stageSaving: false,

      submitVisible: false,
      submitting: false,
      showPayload: [],
      customerOptions: [],
      form: this.emptyForm(),
      rules: {
        company: [{ required: true, message: '请填写客户公司', trigger: 'change' }],
        title: [{ required: true, message: '请填写商机标题', trigger: 'blur' }],
        industry: [{ required: true, message: '请选择行业', trigger: 'change' }],
        website: [{ required: true, message: '请填写客户官网', trigger: 'blur' }],
        problem: [{ required: true, min: 20, message: '客户业务问题至少 20 字', trigger: 'blur' }],
        use_case: [{ required: true, message: '请选择用例', trigger: 'change' }],
        mrr: [{ required: true, type: 'number', min: 1, message: '请填写预计月消费', trigger: 'change' }],
        close_date: [{ required: true, message: '请选择预计关闭日期', trigger: 'change' }],
        apn_user: [{ required: true, message: '请选择 APN 提交人', trigger: 'change' }],
        solution: [{ required: true, message: '请填写解决方案说明', trigger: 'blur' }],
        needs: [{ validator: (r, v, cb) => (this.form.involvement === 'Co-Sell' && !v.length ? cb(new Error('Co-Sell 需至少选择一项 AWS 支持')) : cb()), trigger: 'change' }],
      },
    }
  },
  computed: {
    kpiList() {
      const k = this.ov.kpi
      return [
        { label: '商机总数', value: k.total, iconBg: '#eff6ff', iconColor: '#2563eb', valueColor: '#18181b', go: () => this.gotoList({}) },
        { label: '进行中', value: k.open, iconBg: '#f5f3ff', iconColor: '#7c3aed', valueColor: '#7c3aed', go: () => this.gotoList({ label: '进行中', params: { open: '1' } }) },
        { label: '待提交 / 需补充', value: k.todo, iconBg: '#fff7ed', iconColor: '#ea580c', valueColor: '#ea580c', go: () => this.gotoList({ label: '待提交/需补充', params: { todo: '1' } }) },
        { label: '进行中预计月消费', value: this.fmtUsd(k.open_mrr), iconBg: '#ecfdf5', iconColor: '#059669', valueColor: '#059669' },
        { label: '已关联平台账号', value: k.linked, iconBg: '#f0f9ff', iconColor: '#0284c7', valueColor: '#0284c7', go: () => this.gotoList({ label: '已关联平台账号', params: { linked: '1' } }) },
      ]
    },
    selectedNode() { return this.selected && this.nodeIndex ? this.nodeIndex.get(this.selected.id) : null },
    mapRows() {
      // treeRows 非响应式，靠 treeVersion 触发重算
      if (this.treeVersion < 0) return []
      return this.treeRows || []
    },
    mapSalesOptions() { return [...new Set(this.mapRows.map(r => r.sales || '未分配销售'))].sort() },
    mapAgentOptions() {
      const m = new Map()
      this.mapRows.forEach(r => {
        if (this.mSales && (r.sales || '未分配销售') !== this.mSales) return
        const k = r.agent_id || '-'
        if (!m.has(k)) m.set(k, r.agent_company || r.agent_id || '未分配伙伴')
      })
      return [...m].map(([value, label]) => ({ value, label })).sort((a, b) => a.label.localeCompare(b.label, 'zh'))
    },
    mapScopedRows() {
      return this.mapRows.filter(r => (!this.mSales || (r.sales || '未分配销售') === this.mSales)
        && (!this.mAgent || (r.agent_id || '-') === this.mAgent))
    },
    mapCustomerOptions() {
      const kw = (this.custKw || '').trim().toLowerCase()
      const out = new Set(this.mCustomer ? [this.mCustomer] : [])
      for (const r of this.mapScopedRows) {
        if (out.size >= OPTION_MAX) break
        if (r.customer && (!kw || r.customer.toLowerCase().includes(kw))) out.add(r.customer)
      }
      return [...out]
    },
    mapLinkOptions() {
      const kw = (this.linkKw || '').trim().toLowerCase()
      const out = []
      for (const r of this.mapScopedRows) {
        if (out.length >= OPTION_MAX) break
        if (this.mCustomer && r.customer !== this.mCustomer) continue
        if (!kw || r.link_id.includes(kw) || (r.name || '').toLowerCase().includes(kw)) out.push(r)
      }
      if (this.mLink && !out.some(r => r.link_id === this.mLink)) {
        const cur = this.mapRows.find(r => r.link_id === this.mLink)
        if (cur) out.unshift(cur)
      }
      return out
    },
    ctxNode() { return this.ctxMenu.show && this.nodeIndex ? this.nodeIndex.get(this.ctxMenu.nodeId) : null },
    linkOptions() { return (this.treeRows || []).filter(l => l.customer === this.form.company) },
    payloadPreview() {
      const f = this.form
      const u = APN_USERS.find(x => x.email === f.apn_user)
      const acct = { CompanyName: f.company, Industry: f.industry, WebsiteUrl: f.website, AwsAccountId: f.link_id || undefined, Address: { CountryCode: f.country } }
      return JSON.stringify({
        Catalog: this.ov.write_catalog,
        Origin: 'Partner Referral',
        OpportunityType: f.opp_type,
        NationalSecurity: 'No',
        PrimaryNeedsFromAws: f.involvement === 'Co-Sell' ? f.needs : ['Do Not Need Support from AWS Sales Rep'],
        Customer: { Account: acct },
        Project: {
          Title: f.title, CustomerBusinessProblem: f.problem, CustomerUseCase: f.use_case, DeliveryModels: f.delivery_models,
          ExpectedCustomerSpend: [{ Amount: String(f.mrr || 0), CurrencyCode: 'USD', Frequency: 'Monthly', TargetCompany: 'AWS' }],
          SalesActivities: ['Initialized discussions with customer'],
          OtherSolutionDescription: f.solution,
        },
        LifeCycle: { Stage: f.stage, TargetCloseDate: f.close_date, NextSteps: f.next_steps || undefined },
        OpportunityTeam: u ? [{ Email: u.email, FirstName: u.first, LastName: u.last, BusinessTitle: 'PartnerAccountManager' }] : undefined,
      }, null, 2)
    },
    submitPreview() {
      return JSON.stringify({ Catalog: this.ov.write_catalog, ClientToken: '(uuid)', Identifier: '(CreateOpportunity 返回的 Id)', AwsSubmission: { InvolvementType: this.form.involvement, Visibility: 'Full' } }, null, 2)
    },
  },
  watch: {
    tab(v) {
      this.ctxMenu.show = false
      if (v === 'map') this.$nextTick(() => this.chart && this.chart.resize())
      if (v === 'list' && !this.list.items.length) this.reloadList(1)
      if (v === 'invite' && !this.invites.items.length) this.loadInvites()
    },
    onlyWithOpp() { this.rebuild(true) },
  },
  created() {
    this.treeRows = []
    this.nodeIndex = null
    this.treeRoot = null
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart)
    this.chart.on('click', p => this.onNodeClick(p))
    this.chart.on('contextmenu', p => {
      if (p.event && p.event.event) p.event.event.preventDefault()
      const node = this.nodeIndex && this.nodeIndex.get(p.data && p.data.id)
      if (!node || node.type === 'more') return
      this.selectNode(node)
      this.renderChart()
      this.ctxMenu = { show: true, x: p.event.offsetX + 6, y: p.event.offsetY + 6, nodeId: node.id }
    })
    this.$refs.chart.addEventListener('contextmenu', this.preventCtx)
    this.onResize = () => this.chart && this.chart.resize()
    this.onDocClick = () => { this.ctxMenu.show = false }
    window.addEventListener('resize', this.onResize)
    document.addEventListener('click', this.onDocClick)
    this.loadOverview()
    this.loadTree()
  },
  beforeUnmount() {
    clearTimeout(this.pollTimer)
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('click', this.onDocClick)
    if (this.$refs.chart) this.$refs.chart.removeEventListener('contextmenu', this.preventCtx)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    emptyForm() {
      return {
        client_token: '', company: '', link_id: '', title: '', industry: '', website: '', country: 'CN',
        problem: '', use_case: '', delivery_models: ['Resell'], mrr: 5000, close_date: '', stage: 'Prospect',
        opp_type: 'Net New Business', involvement: 'Co-Sell', needs: [], next_steps: '', apn_user: '',
        solution: 'VSTECS AWS resale, billing and managed services',
      }
    },
    preventCtx(e) { e.preventDefault() },
    fmtUsd(n) { return '$' + Math.round(n || 0).toLocaleString('en-US') },
    fmtK(n) { return n >= 1000 ? '$' + (n / 1000).toFixed(1) + 'K' : '$' + Math.round(n || 0) },
    fmtTime(iso) { const d = new Date(iso); return isNaN(d) ? iso : d.toLocaleString('zh-CN', { hour12: false }).slice(0, 16) },
    stageLabel(v) { const s = STAGES.find(x => x.value === v); return s ? s.label : (v || '-') },
    stageStyle(v) {
      const s = STAGES.find(x => x.value === v)
      const c = s ? s.color : '#64748b'
      return { color: c, borderColor: c + '55', background: c + '12' }
    },
    stageIndex(v) { return Math.max(0, this.openStages.findIndex(s => s.value === v)) },
    reviewMeta(v) { return REVIEW_STATUS[v] || { label: v || '-', cls: 'gray' } },
    inviteMeta(v) { return INVITE_STATUS[v] || { label: v || '-', cls: 'gray' } },
    oppTypeLabel(v) { const t = OPP_TYPES.find(x => x.value === v); return t ? t.label : (v || '-') },
    industryLabel(v) { const t = INDUSTRIES.find(x => x.value === v); return t ? t.label : (v || '-') },
    teamLabel(team) { return (team || []).map(t => `${t.LastName || ''}${t.FirstName || ''} ${t.Email || ''}`.trim()).join('；') || '-' },
    typeChipStyle(t) { const m = TYPE_META[t]; return { color: t === 'root' ? '#fff' : m.color, background: m.bg, borderColor: m.border } },
    pastDate(d) { return d.getTime() < Date.now() - 86400000 },
    me() { return localStorage.getItem('account') || '' },

    // ---------- 数据加载 ----------
    async loadOverview() {
      const res = await apnOverview(this.monthParam()).catch(() => null)
      if (!ok(res)) return ElMessage.error((res && res.msg) || '加载商机概览失败')
      this.ov = res.data
      if (res.data.running) this.pollSync()
    },
    async loadTree() {
      this.treeLoading = true
      const res = await apnTree(this.monthParam()).catch(() => null)
      this.treeLoading = false
      if (!ok(res)) return ElMessage.error((res && res.msg) || '加载账号层级失败')
      const f = res.data.fields
      this.treeRows = res.data.rows.map(r => Object.fromEntries(f.map((k, i) => [k, r[i]])))
      this.treeVersion++
      this.treeMonth = res.data.month
      this.salesOptions = [...new Set(this.treeRows.map(r => r.sales).filter(Boolean))].sort()
      this.rebuild(true)
      this.focusMapFilter()
    },
    monthParam() { return this.fMonth ? { month: this.fMonth } : {} },
    onMonthChange() {
      this.loadOverview()
      this.loadTree()
      if (this.list.items.length || this.tab === 'list') this.reloadList(1)
    },
    onMapFilter(level) {
      // 上级变化时清空下级
      const order = ['sales', 'agent', 'customer', 'link']
      const keys = { sales: 'mSales', agent: 'mAgent', customer: 'mCustomer', link: 'mLink' }
      order.slice(order.indexOf(level) + 1).forEach(k => { this[keys[k]] = '' })
      if (level === 'link' && this.mLink) {
        const r = this.mapRows.find(x => x.link_id === this.mLink)
        if (r) Object.assign(this, { mSales: r.sales || '未分配销售', mAgent: r.agent_id || '-', mCustomer: r.customer })
      }
      this.selected = null
      this.buildModel(false)
      this.chart.clear()
      this.renderChart()
      this.focusMapFilter()
    },
    mapFilterActive() { return !!(this.mSales || this.mAgent || this.mCustomer || this.mLink) },
    clearMapFilters() { Object.assign(this, { mSales: '', mAgent: '', mCustomer: '', mLink: '' }) },
    focusMapFilter() {
      if (!this.nodeIndex || !this.mapFilterActive()) return
      const want = this.mLink ? 'link' : this.mCustomer ? 'customer' : this.mAgent ? 'agent' : 'sales'
      const types = this.view === 'biz' ? ['sales', 'agent', 'customer', 'link'] : ['payer', 'link']
      const depth = this.view === 'biz' ? Math.min(types.indexOf(want) + 2, 4) : 2
      const target = [...this.nodeIndex.values()].find(n => n.type === (this.view === 'biz' ? want : (want === 'link' ? 'link' : 'payer')))
      this.nodeIndex.forEach(n => {
        let d = 0
        for (let p = n.parent; p; p = p.parent) d++
        if (n.children.length) n.collapsed = d >= depth
      })
      if (target) this.selectNode(target)
      this.renderChart()
    },
    reloadList(page) {
      this.list.page = page || this.list.page
      this.list.loading = true
      const params = {
        page: this.list.page, limit: this.list.limit, q: this.q, stage: this.fStage, review: this.fReview,
        origin: this.fOrigin, sales: this.fSales, linked: this.fLinked, ...this.monthParam(), ...this.scopeFilter.params,
      }
      apnList(params).then(res => {
        if (!ok(res)) return ElMessage.error(res.msg || '加载商机失败')
        this.list = { ...this.list, items: res.data.items, total: res.data.total }
      }).finally(() => { this.list.loading = false })
    },
    onSizeChange(n) { this.list.limit = n; this.reloadList(1) },
    loadInvites() {
      this.invites.loading = true
      apnInvitations({ status: this.fInvite }).then(res => {
        if (ok(res)) this.invites = { ...this.invites, items: res.data.items }
      }).finally(() => { this.invites.loading = false })
    },
    syncApn() {
      apnSync({}).then(res => {
        if (!ok(res)) return ElMessage.error(res.msg || '同步失败')
        ElMessage.success(res.msg)
        this.ov = { ...this.ov, running: true }
        this.pollSync()
      })
    },
    pollSync() {
      clearTimeout(this.pollTimer)
      this.pollTimer = setTimeout(async () => {
        const res = await apnOverview(this.monthParam()).catch(() => null)
        if (!ok(res)) return
        this.ov = res.data
        if (res.data.running) return this.pollSync()
        ElMessage.success('APN 同步完成')
        this.loadTree()
        if (this.list.items.length) this.reloadList()
        if (this.invites.items.length) this.loadInvites()
      }, POLL_MS)
    },

    // ---------- 层级树 ----------
    buildModel(keepState) {
      const prev = new Map()
      if (keepState && this.nodeIndex) this.nodeIndex.forEach((n, id) => prev.set(id, { c: n.collapsed, l: n.limit }))
      let rows = this.treeRows
      if (this.onlyWithOpp) rows = rows.filter(r => r.opp_open > 0)
      if (this.mSales) rows = rows.filter(r => (r.sales || '未分配销售') === this.mSales)
      if (this.mAgent) rows = rows.filter(r => (r.agent_id || '-') === this.mAgent)
      if (this.mCustomer) rows = rows.filter(r => r.customer === this.mCustomer)
      if (this.mLink) rows = rows.filter(r => r.link_id === this.mLink)
      const index = new Map()
      const child = (parent, id, type, name, extra) => {
        let n = index.get(id)
        if (!n) {
          n = { id, type, name, children: [], collapsed: true, limit: CHILD_PAGE, linkCount: 0, cost: 0, oppCount: 0, mrr: 0, parent, ...extra }
          index.set(id, n)
          if (parent) parent.children.push(n)
        }
        return n
      }
      const root = child(null, 'root', 'root', this.view === 'biz' ? '佳杰云 业务全景' : '佳杰云 Payer 全景')
      rows.forEach(r => {
        let parent
        if (this.view === 'biz') {
          const sales = r.sales || '未分配销售'
          const s = child(root, `sales:${sales}`, 'sales', sales, { sales: r.sales })
          const aid = `agent:${sales}:${r.agent_id || '-'}`
          const a = child(s, aid, 'agent', r.agent_company || r.agent_id || '未分配伙伴', { agent_id: r.agent_id, sales: r.sales })
          parent = child(a, `customer:${aid}:${r.customer}`, 'customer', r.customer, { customer: r.customer, agent_id: r.agent_id, sales: r.sales })
        } else {
          parent = child(root, `payer:${r.payer_id}`, 'payer', r.payer_name || r.payer_id, { payer_id: r.payer_id, region: r.region })
        }
        const ln = child(parent, `link:${r.link_id}`, 'link', r.name || r.link_id, { linker: r, region: r.region, customer: r.customer })
        ln.linkCount = 1
        ln.cost = r.cost || 0
        ln.oppCount = r.opp_open || 0
        ln.mrr = r.opp_mrr || 0
      })
      const agg = n => {
        n.children.forEach(c => {
          agg(c)
          n.linkCount += c.linkCount
          n.cost += c.cost
          n.oppCount += c.oppCount
          n.mrr += c.mrr
        })
        n.children.sort((a, b) => (b.oppCount - a.oppCount) || (b.cost - a.cost))
      }
      agg(root)
      root.collapsed = false
      index.forEach((n, id) => {
        const p = prev.get(id)
        if (p) { n.collapsed = p.c; n.limit = p.l }
      })
      this.treeRoot = root
      this.nodeIndex = index
    },
    subText(n) {
      const kids = n.children.length
      switch (n.type) {
        case 'root': return this.view === 'biz' ? `${kids} 位销售 · ${n.linkCount} 个账号` : `${kids} 个 Payer · ${n.linkCount} 个账号`
        case 'sales': return `${kids} 个伙伴 · ${n.linkCount} 个账号`
        case 'agent': return `${kids} 个客户 · ${this.fmtK(n.cost)}/月`
        case 'customer': return `${n.linkCount} 个账号 · ${this.fmtK(n.cost)}/月`
        case 'payer': return `${n.payer_id} · ${n.linkCount} 个账号`
        case 'link': return `${n.linker.link_id}${n.region === 'cn' ? ' · 中国区' : ''} · ${this.fmtK(n.cost)}`
        default: return ''
      }
    },
    visibleChildren(n) {
      if (n.collapsed || !n.children.length) return { list: [], rest: 0 }
      const list = n.children.slice(0, n.limit)
      return { list, rest: n.children.length - list.length }
    },
    toChart(n) {
      const m = TYPE_META[n.type]
      const sel = !!this.selected && this.selected.id === n.id
      const dark = sel || n.type === 'root'
      const hasKids = n.children.length > 0
      let text = `{t|${trunc(n.name, 18)}}`
      if (n.oppCount) text += ` {o|${n.oppCount}}`
      if (hasKids && n.collapsed) text += ` {c|+${n.children.length}}`
      text += `\n{s|${this.subText(n)}}`
      const { list, rest } = this.visibleChildren(n)
      const children = list.map(c => this.toChart(c))
      if (rest > 0) {
        const mm = TYPE_META.more
        children.push({
          name: 'more', id: `more:${n.id}`, labelText: `{m|还有 ${rest} 个，点击加载 ${Math.min(rest, CHILD_PAGE)} 个}`, symbolSize: mm.size,
          itemStyle: { color: '#fff', borderColor: mm.color, borderWidth: 1.5 },
          label: { position: 'right', align: 'left', backgroundColor: mm.bg, borderColor: mm.border, borderWidth: 1, borderType: 'dashed', borderRadius: 8, padding: [5, 10], rich: { m: { fontSize: 11.5, color: '#71717a' } } },
        })
      }
      return {
        name: n.name, id: n.id, collapsed: false, labelText: text, symbolSize: m.size,
        itemStyle: { color: hasKids && n.collapsed ? m.color : '#fff', borderColor: m.color, borderWidth: 2 },
        label: {
          position: children.length ? 'left' : 'right', align: children.length ? 'right' : 'left', distance: 8,
          backgroundColor: sel ? m.color : m.bg, borderColor: sel ? m.color : m.border, borderWidth: 1,
          borderType: n.region === 'cn' && n.type === 'link' ? 'dashed' : 'solid', borderRadius: 8, padding: [6, 10],
          shadowBlur: sel ? 14 : 0, shadowColor: 'rgba(15,23,42,.25)',
          rich: {
            t: { fontSize: 12.5, fontWeight: 600, color: dark ? '#fff' : '#18181b', lineHeight: 18 },
            s: { fontSize: 11, color: dark ? 'rgba(255,255,255,.78)' : '#71717a', lineHeight: 16 },
            o: { fontSize: 10, fontWeight: 700, color: '#fff', backgroundColor: '#f97316', borderRadius: 8, padding: [2, 6] },
            c: { fontSize: 10, fontWeight: 700, color: dark ? '#fff' : m.color, borderColor: dark ? '#fff' : m.color, borderWidth: 1, borderRadius: 8, padding: [1, 5] },
          },
        },
        children,
      }
    },
    countVisibleLeaves(n) {
      const { list, rest } = this.visibleChildren(n)
      if (!list.length) return 1
      return list.reduce((s, c) => s + this.countVisibleLeaves(c), 0) + (rest > 0 ? 1 : 0)
    },
    applyOption() {
      this.chart.setOption({
        series: [{
          type: 'tree', data: [this.toChart(this.treeRoot)], orient: 'LR',
          left: 230, right: 260, top: 30, bottom: 30, roam: 'move', expandAndCollapse: false, symbol: 'circle',
          edgeShape: 'curve', lineStyle: { color: '#cbd5e1', width: 1.4, curveness: 0.5 },
          label: { formatter: p => p.data.labelText || p.name },
          emphasis: { focus: 'ancestor', lineStyle: { color: '#64748b', width: 2 } },
          animationDuration: 350, animationDurationUpdate: 400,
        }],
      })
    },
    renderChart() {
      if (!this.chart || !this.treeRoot) return
      const h = Math.max(520, this.countVisibleLeaves(this.treeRoot) * 52 + 60)
      if (h !== this.chartHeight) {
        this.chartHeight = h
        this.$nextTick(() => { this.chart.resize(); this.applyOption() })
      } else {
        this.applyOption()
      }
    },
    rebuild(keepState) {
      this.buildModel(keepState)
      if (this.selected) {
        const n = this.nodeIndex.get(this.selected.id)
        this.selected = n ? this.snapshot(n) : null
      }
      this.renderChart()
    },
    snapshot(n) {
      return { id: n.id, type: n.type, name: n.name, sub: this.subText(n), region: n.region, linkCount: n.linkCount, cost: n.cost, oppCount: n.oppCount, mrr: n.mrr }
    },
    nodeLinkIds(n) {
      const out = []
      const walk = x => { if (x.type === 'link') out.push(x.linker.link_id); x.children.forEach(walk) }
      walk(n)
      return out
    },
    nodeScope(n) {
      if (n.type === 'link' || n.type === 'customer') return { label: n.name, params: { link_ids: this.nodeLinkIds(n).join(',') } }
      if (n.type === 'agent') return { label: n.name, params: { agent_id: n.agent_id || '' } }
      if (n.type === 'sales') return { label: n.name, params: { sales: n.sales || '' } }
      if (n.type === 'payer') return { label: n.name, params: { payer_id: n.payer_id } }
      return { label: '已关联平台账号', params: { linked: '1' } }
    },
    selectNode(n) {
      this.selected = this.snapshot(n)
      const sc = this.nodeScope(n)
      this.sideOpps = { items: [], total: 0, loading: true }
      const want = n.id
      apnList({ page: 1, limit: SIDE_LIMIT, ...this.monthParam(), ...sc.params }).then(res => {
        if (!this.selected || this.selected.id !== want || !ok(res)) return
        this.sideOpps = { items: res.data.items, total: res.data.total, loading: false }
      }).finally(() => { if (this.selected && this.selected.id === want) this.sideOpps.loading = false })
    },
    onNodeClick(p) {
      const id = p.data && p.data.id
      if (!id) return
      this.ctxMenu.show = false
      if (id.startsWith('more:')) {
        const parent = this.nodeIndex.get(id.slice(5))
        if (parent) { parent.limit += CHILD_PAGE; this.renderChart() }
        return
      }
      const n = this.nodeIndex.get(id)
      if (!n) return
      const already = this.selected && this.selected.id === n.id
      if (n.children.length && (already || n.collapsed)) n.collapsed = !n.collapsed
      if (!already) this.selectNode(n)
      this.renderChart()
    },
    switchView(v) {
      if (this.view === v) return
      this.view = v
      this.selected = null
      this.buildModel(false)
      this.chart.clear()
      this.renderChart()
      this.focusMapFilter()
    },
    collapseAll() {
      this.nodeIndex.forEach(n => { if (n.type !== 'root') { n.collapsed = true; n.limit = CHILD_PAGE } })
      this.renderChart()
    },
    resetView() { this.chart.clear(); this.renderChart() },
    locate(id) {
      let n = this.nodeIndex.get(id)
      if (!n && (this.onlyWithOpp || this.mapFilterActive())) {
        this.onlyWithOpp = false
        this.clearMapFilters()
        this.buildModel(true)
        n = this.nodeIndex.get(id)
      }
      if (!n) return ElMessage.warning('当前视角下未找到该节点（可能无权限或账号已停用）')
      for (let c = n, p = n.parent; p; c = p, p = p.parent) {
        p.collapsed = false
        const idx = p.children.indexOf(c)
        if (idx >= p.limit) p.limit = idx + 1
      }
      this.selectNode(n)
      this.renderChart()
    },
    onLocate(id) { if (id) this.locate(id) },
    locateLink(linkId) {
      if (!linkId) return
      this.drawer = false
      this.tab = 'map'
      this.$nextTick(() => this.locate(`link:${linkId}`))
    },
    nodeActions(n) {
      if (!n) return []
      const cn = n.type === 'link' && n.region === 'cn'
      const map = {
        root: [{ key: 'opps', label: '查看全部商机' }],
        sales: [{ key: 'opps', label: '查看商机' }, { key: 'sales', label: '销售管理' }],
        agent: [{ key: 'submit', label: '提交商机', primary: true }, { key: 'opps', label: '查看商机' }, { key: 'agent', label: '伙伴管理' }],
        customer: [{ key: 'submit', label: '为该客户提交商机', primary: true }, { key: 'opps', label: '查看商机' }, { key: 'customer', label: '客户管理' }],
        payer: [{ key: 'opps', label: '查看商机' }, { key: 'payer', label: 'Payer 管理' }],
        link: [
          { key: 'submit', label: '提交商机', primary: true, disabled: cn, tip: cn ? 'AWS 中国区账号不在 APN/ACE 覆盖范围' : '' },
          { key: 'cost', label: '成本分析' }, { key: 'bill', label: '账单管理' }, { key: 'linker', label: '账号管理' },
        ],
      }
      return map[n.type] || []
    },
    doAction(key, id) {
      this.ctxMenu.show = false
      const n = this.nodeIndex.get(id)
      if (!n) return
      if (key === 'submit') return this.openSubmit(n)
      if (key === 'opps') return this.gotoList(this.nodeScope(n))
      const query = {}
      if (n.linker) query.link_id = n.linker.link_id
      if (n.agent_id) query.agent_id = n.agent_id
      if (n.payer_id) query.payer_id = n.payer_id
      this.goPage(ROUTES[key], query)
    },
    goPage(path, query) { this.$router.push({ path, query }) },
    gotoList(scope) {
      Object.assign(this, { q: '', fStage: '', fReview: '', fOrigin: '', fSales: '', fLinked: '' })
      this.scopeFilter = { label: scope.label || '', params: scope.params || {} }
      this.tab = 'list'
      this.reloadList(1)
    },
    clearScope() { this.scopeFilter = { label: '', params: {} }; this.reloadList(1) },

    // ---------- 商机详情 / 写操作 ----------
    openDrawer(id) {
      this.drawer = true
      this.nextStage = ''
      this.detail = { data: null, loading: true }
      apnDetail({ id }).then(res => {
        if (!ok(res)) { ElMessage.error(res.msg || '加载详情失败'); this.drawer = false; return }
        this.detail = { data: res.data, loading: false }
      }).finally(() => { this.detail.loading = false })
    },
    updateStage() {
      const d = this.detail.data
      this.stageSaving = true
      apnUpdateStage({ id: d.id, stage: this.nextStage }).then(res => {
        if (!ok(res)) return ElMessage.error(res.msg)
        ElMessage.success(res.msg)
        this.openDrawer(d.id)
        this.loadOverview()
      }).finally(() => { this.stageSaving = false })
    },
    inviteAction(it, action) {
      const verb = action === 'accept' ? '接受' : '拒绝'
      ElMessageBox.confirm(`确认${verb}「${it.title}」？该操作会同步到 APN。`, `${verb} AWS 推荐`, { type: 'warning' })
        .then(() => apnInvitationAction({ id: it.id, action }))
        .then(res => {
          if (!res) return
          if (!ok(res)) return ElMessage.error(res.msg)
          ElMessage.success(res.msg)
          this.loadInvites()
          this.loadOverview()
        })
        .catch(() => {})
    },
    openSubmit(node) {
      const f = this.emptyForm()
      f.client_token = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : String(Date.now())
      let sales = this.me()
      if (node) {
        if (node.type === 'link') {
          f.company = node.linker.customer
          f.link_id = node.linker.link_id
          sales = node.linker.sales || sales
        } else if (node.type === 'customer') {
          f.company = node.customer
          const l = this.treeRows.find(x => x.customer === node.customer && x.region !== 'cn')
          f.link_id = l ? l.link_id : ''
          sales = node.sales || sales
        } else if (node.sales) {
          sales = node.sales
        }
      }
      f.apn_user = apnUserOfSales(sales)
      f.title = f.company ? `${f.company} ` : ''
      this.customerOptions = f.company ? [f.company] : []
      this.form = f
      this.showPayload = []
      this.submitVisible = true
      this.$nextTick(() => this.$refs.oppForm && this.$refs.oppForm.clearValidate())
    },
    searchCustomers(kw) {
      kw = (kw || '').trim().toLowerCase()
      const seen = new Set()
      for (const r of this.treeRows) {
        if (r.customer && (!kw || r.customer.toLowerCase().includes(kw))) seen.add(r.customer)
        if (seen.size >= 50) break
      }
      this.customerOptions = [...seen]
    },
    onCompanyChange() {
      const l = this.treeRows.find(x => x.customer === this.form.company && x.region !== 'cn')
      this.form.link_id = l ? l.link_id : ''
      if (l && l.sales) {
        const u = apnUserOfSales(l.sales)
        if (u) this.form.apn_user = u
      }
    },
    saveOpp(submit) {
      this.$refs.oppForm.validate().then(() => {
        const prodWarn = this.ov.write_catalog === 'AWS'
          ? ElMessageBox.confirm('将写入 AWS 生产 Partner Central，提交后 AWS 会审核，确认继续？', '写入生产', { type: 'warning' })
          : Promise.resolve()
        return prodWarn.then(() => {
          const u = APN_USERS.find(x => x.email === this.form.apn_user) || {}
          this.submitting = true
          return apnCreate({ ...this.form, submit, apn_user_email: u.email, apn_user_first: u.first, apn_user_last: u.last })
        })
      }).then(res => {
        if (!res) return
        if (!ok(res)) return ElMessage.error(res.msg)
        ElMessage.success(res.msg)
        this.submitVisible = false
        this.loadOverview()
        this.loadTree()
        this.reloadList(1)
        this.openDrawer(res.data.id)
      }).catch(() => {}).finally(() => { this.submitting = false })
    },
  },
}
</script>

<style lang="scss" scoped>
.ca-page { background: #f0f2f5 !important; min-height: 100%; font-family: -apple-system, 'SF Pro Text', 'PingFang SC', 'Microsoft YaHei', sans-serif; letter-spacing: -0.011em; color: #1b1b1f; }
.ca-body { padding: 20px; display: flex; flex-direction: column; gap: 16px; }
.ca-toolbar { display: flex; align-items: center; gap: 10px; }
.ca-toolbar-title { font-size: 18px; font-weight: 700; color: #18181b; }
.ca-toolbar-spacer { flex: 1; }
.ca-export-btn { display: inline-flex; align-items: center; gap: 7px; height: 34px; padding: 0 16px; border-radius: 8px; font-size: 13px; font-weight: 600; color: #fff; cursor: pointer; border: none; background: #232f3e; transition: background .15s; }
.ca-export-btn:hover { background: #31465f; }
.ca-export-btn:disabled { opacity: .45; cursor: not-allowed; }
.ca-ghost-btn { display: inline-flex; align-items: center; height: 34px; padding: 0 14px; border-radius: 8px; font-size: 13px; font-weight: 600; color: #3f3f46; cursor: pointer; border: 1px solid #e4e4e7; background: #fff; transition: all .15s; }
.ca-ghost-btn:hover:not(:disabled) { border-color: #a1a1aa; color: #18181b; }
.ca-ghost-btn:disabled { opacity: .45; cursor: not-allowed; }
.ca-ghost-sm, .ca-btn-sm { height: 30px; padding: 0 12px; font-size: 12px; }
.ca-kpi-row { display: grid; grid-template-columns: repeat(5, 1fr); gap: 12px; }
.ca-kpi-card { background: #fff; border: 1px solid #e4e4e7; border-radius: 8px; padding: 12px 16px; display: flex; align-items: center; gap: 12px; }
.ca-kpi-icon-wrap { width: 36px; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.ca-kpi-label { font-size: 12px; color: #71717a; }
.ca-kpi-value { font-size: 24px; font-weight: 700; font-variant-numeric: tabular-nums; line-height: 1.2; }
.ca-card { background: #fff; border: 1px solid #e4e4e7; border-radius: 8px; overflow: hidden; }
.ca-card-header { padding: 10px 20px; border-bottom: 1px solid #e4e4e7; display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.ca-card-header-between { justify-content: space-between; }
.ca-tab-badge { display: inline-block; font-size: 10px; line-height: 1; padding: 2px 5px; border-radius: 9999px; margin-left: 4px; font-weight: 600; }
.ca-badge-orange { background: #fff7ed; color: #c2410c; }
.ca-badge-blue { background: #eff6ff; color: #1d4ed8; }
.ca-filters { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
.ca-filter-select { width: 160px; }
.ca-filter-sm { width: 130px; }
.ca-filters :deep(.el-input__wrapper) { height: 32px; }
.ca-filters :deep(.el-input__inner) { font-size: 12px; }
.ca-empty { padding: 32px 20px; text-align: center; font-size: 13px; color: #71717a; }
.ca-sev-badge { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 500; padding: 2px 7px; border-radius: 4px; border: 1px solid; white-space: nowrap; }
.ca-sev-critical { background: #fef2f2; color: #b91c1c; border-color: #fecaca; }
.ca-sev-info { background: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; }
.ca-sev-green { background: #ecfdf5; color: #047857; border-color: #a7f3d0; }
.ca-sev-orange { background: #fff7ed; color: #c2410c; border-color: #fed7aa; }
.ca-sev-purple { background: #faf5ff; color: #7c3aed; border-color: #ddd6fe; }
.ca-sev-gray { background: #f9fafb; color: #4b5563; border-color: #e5e7eb; }
.ca-text-primary { color: #2563eb; }
.ca-text-muted { color: #71717a; }
.ca-detail-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
.ca-detail-label { font-size: 11px; color: #71717a; margin-bottom: 2px; }
.ca-detail-value { font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; color: #1b1b1f; }
.ca-detail-text { font-size: 13px; font-weight: 500; word-break: break-all; }
.ca-detail-desc { font-size: 12px; color: #71717a; line-height: 1.6; }
.ca-table-wrap { overflow-x: auto; min-height: 120px; }
.ca-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.ca-table thead th { text-align: left; padding: 10px 12px; font-weight: 500; color: #71717a; white-space: nowrap; background: rgba(244,244,245,0.3); border-bottom: 1px solid #e4e4e7; }
.ca-table tbody td { padding: 10px 12px; vertical-align: top; }
.ca-table-row { border-bottom: 1px solid #e4e4e7; transition: background 0.15s; }
.ca-table-row:last-child { border-bottom: none; }
.ca-table-row:hover { background: rgba(244,244,245,0.5); }
.ca-td-primary { color: #2563eb; font-weight: 500; }
.ca-td-bold { color: #1b1b1f; font-weight: 500; }
.ca-td-muted { color: #71717a; font-size: 11px; margin-top: 2px; }
.ca-font-data { font-variant-numeric: tabular-nums; }
.ca-nowrap { white-space: nowrap; }

.om-partner { font-size: 12px; font-weight: 600; color: #3f3f46; background: #fff; border: 1px solid #e4e4e7; padding: 3px 10px; border-radius: 20px; }
.om-conn { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; color: #3f3f46; background: #fff; border: 1px solid #e4e4e7; border-radius: 20px; padding: 5px 12px; }
.om-conn-dot { width: 7px; height: 7px; border-radius: 50%; background: #10b981; box-shadow: 0 0 0 3px rgba(16,185,129,.15); }
.om-conn-dot.busy { background: #f59e0b; box-shadow: 0 0 0 3px rgba(245,158,11,.2); animation: om-pulse 1s infinite; }
@keyframes om-pulse { 50% { opacity: .35; } }
.om-conn-time { color: #a1a1aa; margin-left: 4px; }
.om-kpi-click { cursor: pointer; transition: border-color .15s, box-shadow .15s; }
.om-kpi-click:hover { border-color: #c7c7cc; box-shadow: 0 2px 8px rgba(0,0,0,.04); }
.om-kpi-dot { width: 12px; height: 12px; border-radius: 4px; }

.om-tabs { display: flex; gap: 4px; }
.om-tab { height: 32px; padding: 0 14px; border: none; background: none; font-size: 13px; color: #71717a; font-weight: 500; cursor: pointer; border-radius: 6px; }
.om-tab:hover { background: #f4f4f5; }
.om-tab.active { color: #18181b; font-weight: 700; background: #f4f4f5; }
.om-seg { display: inline-flex; background: #f4f4f5; border-radius: 7px; padding: 2px; }
.om-seg button { height: 28px; padding: 0 12px; border: none; background: none; font-size: 12px; color: #71717a; border-radius: 5px; cursor: pointer; font-weight: 500; }
.om-seg button.active { background: #fff; color: #18181b; font-weight: 700; box-shadow: 0 1px 2px rgba(0,0,0,.08); }
.om-m-sm { width: 120px; }
.om-m-md { width: 170px; }
.om-month { width: 140px !important; }
.om-month :deep(.el-input__wrapper) { height: 32px; }
.om-month-tip { font-size: 12px; color: #a1a1aa; }
.om-switch-label { font-size: 12px; color: #3f3f46; margin-left: 4px; }

.om-map-layout { display: grid; grid-template-columns: minmax(0, 1fr) 340px; min-height: 600px; }
.om-map-main { border-right: 1px solid #e4e4e7; min-width: 0; display: flex; flex-direction: column; }
.om-legend { display: flex; align-items: center; gap: 14px; padding: 10px 20px; border-bottom: 1px dashed #e4e4e7; font-size: 12px; color: #52525b; flex-wrap: wrap; }
.om-legend-item { display: inline-flex; align-items: center; gap: 6px; }
.om-legend-item i { width: 14px; height: 10px; border-radius: 3px; border: 1.5px solid; }
.om-legend-opp { font-size: 10px; color: #fff; background: #f97316; border-radius: 8px; padding: 1px 6px; }
.om-legend-hint { margin-left: auto; color: #a1a1aa; }
.om-chart-scroll { overflow: auto; max-height: 760px; background-image: radial-gradient(#e4e4e7 1px, transparent 1px); background-size: 18px 18px; }
.om-chart-inner { position: relative; min-width: 1100px; }
.om-chart { width: 100%; }
.om-ctx { position: absolute; z-index: 10; min-width: 150px; background: #fff; border: 1px solid #e4e4e7; border-radius: 8px; box-shadow: 0 8px 24px rgba(15,23,42,.14); padding: 4px; }
.om-ctx-title { font-size: 11px; color: #a1a1aa; padding: 6px 10px 4px; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.om-ctx-item { display: block; width: 100%; text-align: left; border: none; background: none; padding: 7px 10px; font-size: 13px; color: #27272a; border-radius: 5px; cursor: pointer; }
.om-ctx-item:hover:not(:disabled) { background: #f4f4f5; }
.om-ctx-item:disabled { color: #c4c4c8; cursor: not-allowed; }

.om-side { padding: 16px 18px; display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.om-side-empty { margin: auto; text-align: center; font-size: 13px; color: #a1a1aa; line-height: 1.8; }
.om-side-empty-icon { font-size: 30px; color: #d4d4d8; margin-bottom: 6px; }
.om-type-chip { display: inline-block; font-size: 11px; font-weight: 700; border: 1px solid; border-radius: 4px; padding: 1px 7px; }
.om-side-name { font-size: 17px; font-weight: 700; color: #18181b; margin-top: 8px; word-break: break-all; }
.om-side-sub { font-size: 12px; color: #71717a; margin-top: 2px; font-variant-numeric: tabular-nums; }
.om-cn-tip { margin-top: 8px; font-size: 12px; color: #b45309; background: #fffbeb; border: 1px solid #fde68a; border-radius: 6px; padding: 6px 10px; }
.om-side-stats { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; background: #fafafa; border: 1px solid #f0f0f2; border-radius: 8px; padding: 12px 14px; }
.om-side-actions { display: flex; flex-wrap: wrap; gap: 8px; }
.om-side-section { font-size: 12px; font-weight: 700; color: #3f3f46; display: flex; align-items: center; }
.om-more-link { margin-left: auto; font-weight: 500; color: #2563eb; cursor: pointer; }
.om-side-opps { display: flex; flex-direction: column; gap: 8px; max-height: 420px; overflow: auto; min-height: 60px; }
.om-opp-mini { border: 1px solid #e4e4e7; border-radius: 8px; padding: 10px 12px; cursor: pointer; transition: border-color .15s, background .15s; }
.om-opp-mini:hover { border-color: #93c5fd; background: #f8fbff; }
.om-opp-mini-title { font-size: 13px; font-weight: 600; color: #18181b; }
.om-opp-mini-meta { display: flex; align-items: center; gap: 6px; margin-top: 6px; font-size: 12px; flex-wrap: wrap; }

.om-list-filters { padding: 12px 20px; border-bottom: 1px solid #e4e4e7; }
.om-scope-chip { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 600; color: #1d4ed8; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 6px; padding: 4px 8px; }
.om-scope-chip b { cursor: pointer; font-size: 14px; line-height: 1; }
.om-q { width: 260px; }
.om-td-title { max-width: 320px; }
.om-link { cursor: pointer; }
.om-link:hover { text-decoration: underline; }
.om-cat-tag { margin-left: 6px; font-size: 10px; font-weight: 700; color: #0369a1; background: #f0f9ff; border: 1px solid #bae6fd; border-radius: 4px; padding: 0 5px; }
.om-op { border: none; background: none; color: #2563eb; font-size: 12px; cursor: pointer; padding: 0 6px; }
.om-op:disabled { color: #c4c4c8; cursor: not-allowed; }
.om-op-primary { font-weight: 700; color: #ea580c; }
.om-pager { display: flex; justify-content: flex-end; padding: 12px 20px; border-top: 1px solid #e4e4e7; }

.om-invite-wrap { padding: 16px 20px; }
.om-invite-tip { font-size: 12px; color: #71717a; margin-bottom: 10px; }
.om-invite-filter { margin-bottom: 10px; }

.om-drawer-body { display: flex; flex-direction: column; gap: 18px; padding: 4px 4px 20px; min-height: 200px; }
.om-drawer-title { font-size: 18px; font-weight: 700; color: #18181b; }
.om-drawer-badges { display: flex; align-items: center; gap: 8px; margin-top: 8px; flex-wrap: wrap; }
.om-drawer-grid { grid-template-columns: 1fr 1fr; background: #fafafa; border: 1px solid #f0f0f2; border-radius: 8px; padding: 14px 16px; }
.om-steps :deep(.el-step__title) { font-size: 12px; }
.om-lost { font-size: 13px; color: #6b7280; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 10px 14px; }
.om-review-note { font-size: 12px; color: #b45309; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; padding: 8px 12px; }
.om-problem { color: #3f3f46; margin-top: 4px; white-space: pre-wrap; }
.om-stage-update { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.om-timeline { margin-top: 10px; padding-left: 2px; }
.om-drawer-foot { display: flex; gap: 8px; flex-wrap: wrap; border-top: 1px solid #e4e4e7; padding-top: 14px; }

.om-dialog-title { font-size: 16px; font-weight: 700; color: #18181b; }
.om-form-group { font-size: 13px; font-weight: 700; color: #18181b; margin: 4px 0 10px; padding-left: 8px; border-left: 3px solid #232f3e; }
.om-form :deep(.el-form-item) { margin-bottom: 14px; }
.om-form :deep(.el-form-item__label) { font-size: 12px; color: #52525b; padding-bottom: 2px; }
.om-payload { margin-top: 4px; }
.om-payload-step { font-size: 12px; font-weight: 700; color: #3f3f46; margin: 6px 0; }
.om-payload pre { background: #0f172a; color: #e2e8f0; font-size: 11.5px; line-height: 1.55; border-radius: 8px; padding: 12px 14px; max-height: 260px; overflow: auto; margin: 0 0 8px; }
.om-foot-tip { font-size: 12px; color: #a1a1aa; margin-right: 12px; }
</style>
